import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './WebTrainingScreen.module.scss'
import {
  DesktopBodyLarge,
  DesktopButton,
  DesktopHeadlineLarge,
  DesktopTitleLarge,
} from '../../Typography'
import YouTube from 'react-youtube'
import { TrainingScreenData } from './TrainingScreen'
import { ROUTES } from '../../config/routes'

type Props = {
  data: TrainingScreenData
}

export const WebTrainingScreen = ({ data }: Props): ReactElement => {
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
      <div className={styles.textVideoContainer}>
        <div className={styles.textContainer}>
          <div className={styles.textBox}>
            <DesktopHeadlineLarge marginBottom={2}>Training</DesktopHeadlineLarge>
            <DesktopBodyLarge>
              FIGHTBACK-WRESTLING ist stets auf der Suche nach neuen Talenten!
            </DesktopBodyLarge>
            <DesktopBodyLarge>
              Die ersten Trainingseinheiten sind unverbindlich und geben dir die Möglichkeit, deine
              ersten Schritte im Wrestling zu machen.
              <br />
              Die Neulinge bekommen die Chance, sich vorzustellen und ihre Leistung im Training zu
              präsentieren.
              <br />
              Hinterher wird in Absprache mit dem Trainerstab entschieden, ob eine Weiterführung der
              Wrestlerausbildung möglich und sinnvoll ist.
              <br />
              Dabei spielen Einstellung,Verhalten, Respekt und Leistung eine wichtige Rolle.
            </DesktopBodyLarge>
            <DesktopBodyLarge>
              Die Dauer der Wrestlingausbildung ist von Person zu Person höchst unterschiedlich und
              hängt nicht zuletzt von den oben genannten Punkten ab.
            </DesktopBodyLarge>
            <div
              className={styles.button}
              onClick={(): void =>
                navigate(ROUTES.contact, { state: 'Ich möchte in den Ring steigen', replace: true })
              }
            >
              <DesktopButton darkFont={true}>KONTAKT</DesktopButton>
            </div>
          </div>
          <div className={styles.textBox}>
            <DesktopHeadlineLarge marginBottom={2}>Trainingsablauf</DesktopHeadlineLarge>
            <DesktopBodyLarge>
              Fallschule & Einsatz der Fallschule
              <br />
              {' \u2022 '} Basic Wrestling (traditionelles Mattenwrestling)
              <br />
              {' \u2022 '} klassische Wrestlingaktionen
              <br />
              {' \u2022 '} Bewegung, Gestik und Mimik eines Wrestlers
              <br />
              {' \u2022 '} Matchaufbau / Improvisation / Trainingsmatches
            </DesktopBodyLarge>
            <DesktopBodyLarge>
              Als Neuling bekommst du zunächst die Basis, also die Fallschule und deren Einsatz
              beigebracht. Erst wenn du diese sicher beherrschst, kann man einen Schritt weitergehen
              und mit Aktionen beginnen. Deine Sicherheit und die deines Gegners haben absolute
              Priorität!
            </DesktopBodyLarge>
            <DesktopBodyLarge>
              Am Ende einer erfolgreich verlaufenen Trainingszeit bist du in der Lage, dich als
              Wrestler zu präsentieren und mit deinem Gegner ein ansehnliches Match zu bestreiten.
            </DesktopBodyLarge>
          </div>
        </div>
        <div className={styles.videoContainer}>
          {data.cookiesAccepted ? (
            <YouTube videoId={data.youtubeVideoId} />
          ) : (
            <div className={styles.cookieWarning}>
              <DesktopBodyLarge>
                Dieses eingebettete Video kann nicht angezeigt werden, da du der Verwendung von
                Cookies und der Datenübertragung an YouTube nicht zugestimmt hast.
              </DesktopBodyLarge>
              <DesktopBodyLarge>
                Mit dem Klick auf den unten stehenden Text erklärst du dich einverstanden, dass
                Inhalte von YouTube geladen werden dürfen. Dabei können personenbezogene Daten an
                YouTube übermittelt werden.
              </DesktopBodyLarge>
              <div onClick={data.onAcceptCookies}>
                <DesktopBodyLarge className={styles.acceptCookies}>
                  Cookies für YouTube akzeptieren
                </DesktopBodyLarge>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.placesRow}>
        <div className={styles.placeBox}>
          <img src={data.factoryImageUrl} alt={'Factory Image'} />
          <div className={styles.placeDescriptionRow}>
            <div className={styles.info}>
              <DesktopTitleLarge>Fightback Factory</DesktopTitleLarge>
              <div>
                <DesktopBodyLarge>Am Südpark 12</DesktopBodyLarge>
                <DesktopBodyLarge>65451 Kelsterbach</DesktopBodyLarge>
              </div>
            </div>
            <div className={styles.info}>
              <DesktopTitleLarge>Mo & Mi</DesktopTitleLarge>
              <DesktopBodyLarge>18:30 Uhr - 20:30 Uhr</DesktopBodyLarge>
            </div>
          </div>
        </div>
        <div className={styles.placeBox}>
          <img src={data.sgsImageUrl} alt={'SGS Image'} />
          <div className={styles.placeDescriptionRow}>
            <div className={styles.info}>
              <DesktopTitleLarge>SGS Halle</DesktopTitleLarge>
              <div>
                <DesktopBodyLarge>Westerbachstraße 274A</DesktopBodyLarge>
                <DesktopBodyLarge>65936 Frankfurt / Sossenheim</DesktopBodyLarge>
              </div>
            </div>
            <div className={styles.info}>
              <DesktopTitleLarge>Sonntags</DesktopTitleLarge>
              <DesktopBodyLarge>13:00 Uhr - 17:00 Uhr</DesktopBodyLarge>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
